export function H3(props) {
  return (
    <h3 className="pd-panel__header--h3" id={props.id}>
      {props.children}
    </h3>
  );
}

export default H3;
